import { TGetFundingRequirementsResponse } from '../../../api/lending/edge';

type RequirementCheckType = 'visibility' | 'completeness';

export const getRequirementByResolutionMethod = (
  requirements: TGetFundingRequirementsResponse['data'],
  resolution_method: TGetFundingRequirementsResponse['data'][number]['recommended_resolution_method'],
) => {
  return requirements?.find(
    (requirement) =>
      requirement.recommended_resolution_method === resolution_method,
  );
};

const getIsVisible = (
  requirement: TGetFundingRequirementsResponse['data'][number],
) => {
  return requirement.status !== 'completed';
};

const getIsCompleted = (
  requirement: TGetFundingRequirementsResponse['data'][number],
) => requirement.status !== 'required';

const checkTypeMapper: Record<
  RequirementCheckType,
  (requirement: TGetFundingRequirementsResponse['data'][number]) => boolean
> = {
  visibility: getIsVisible,
  completeness: getIsCompleted,
};

export const checkRequirement = (
  fundingRequirement: TGetFundingRequirementsResponse['data'],
  resolution_method: TGetFundingRequirementsResponse['data'][number]['recommended_resolution_method'],
  checkType: RequirementCheckType,
) => {
  const requirement = getRequirementByResolutionMethod(
    fundingRequirement,
    resolution_method,
  );

  if (!requirement) return false;

  return checkTypeMapper[checkType](requirement);
};
